var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52778 7.41667C8.52778 8.00604 8.7619 8.57127 9.17865 8.98801C9.5954 9.40476 10.1606 9.63889 10.75 9.63889C11.3394 9.63889 11.9046 9.40476 12.3213 8.98801C12.7381 8.57127 12.9722 8.00604 12.9722 7.41667C12.9722 6.8273 12.7381 6.26207 12.3213 5.84532C11.9046 5.42857 11.3394 5.19444 10.75 5.19444C10.1606 5.19444 9.5954 5.42857 9.17865 5.84532C8.7619 6.26207 8.52778 6.8273 8.52778 7.41667Z",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 7.41667C18.0833 11.8611 14.75 14.0833 10.75 14.0833C6.75 14.0833 3.41667 11.8611 0.75 7.41667C3.41667 2.97222 6.75 0.75 10.75 0.75C14.75 0.75 18.0833 2.97222 20.75 7.41667Z",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.89ad3097b836bf3b23a3ca8efb7b956e.svg";
export { ForwardRef as ReactComponent };